import { Component } from '@angular/core';
import { ContentNavigatorTableComponent } from '@shared/components/content-navigator/content-navigator-table/content-navigator-table.component';
import {
  ContentNavigatorTableRow
} from '@shared/models/content-navigator/content-navigator.model';

@Component({
    selector: 'app-pa-content-navigator-table',
    templateUrl: './pa-content-navigator-table.component.html',
    styleUrls: ['./pa-content-navigator-table.component.scss'],
    standalone: false
})
export class PaContentNavigatorTableComponent extends ContentNavigatorTableComponent<ContentNavigatorTableRow> {}
